import { COINS } from '@constants/redux';

const initialState = {
  vaults: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case COINS.EDIT.ON_VAULTS_RECEIVED:
      return { ...state, vaults: action.vaults };
    default:
      return state;
  }
};
